import { render, staticRenderFns } from "./Word.vue?vue&type=template&id=5bafde5c&"
import script from "./Word.vue?vue&type=script&lang=js&"
export * from "./Word.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports